import { createFeatureRouter } from './factory/featureFactory';

export default createFeatureRouter();
